import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { AuthRepository, UserRole } from '../auth.repository';

/**
 * SuperUser and SysAdmin only, decided by the account role alone.
 * Unlike the other guards there is no is_admin / permissions bypass: those values
 * come from RBAC roles, which are exactly what these pages manage.
 */
@Injectable({
  providedIn: 'root'
})
export class GlobalAdminGuard implements CanActivate, CanActivateChild {

  constructor(
    private authRepository: AuthRepository,
    private router: Router
  ) {}

  canActivate(): boolean {
    return this.isGlobalAdmin();
  }

  canActivateChild(): boolean {
    return this.isGlobalAdmin();
  }

  private isGlobalAdmin(): boolean {
    const user = this.authRepository.getUser();
    if (!user) {
      this.router.navigate(['/sign-in']);
      return false;
    }
    if (user.role === UserRole.SuperUser || user.role === UserRole.SysAdmin) {
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }
}
